import React, { useState } from "react";

import styles from "./ScollTop.module.css";

import Fab from "@material-ui/core/Fab";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Tooltip from "@material-ui/core/Tooltip";

const ScrollTop = ({ name }) => {
  const [display, setDisplay] = useState(false);

  window.addEventListener("scroll", () => {
    if (window.scrollY >= 100) {
      setDisplay(true);
    } else {
      setDisplay(false);
    }
  });

  if (display) {
    return (
      <div className={styles.container}>
        <Tooltip title="Move on top" aria-label="add">
          <Fab color="secondary" aria-label="scroll back to top" size="small">
            <KeyboardArrowUpIcon />
          </Fab>
        </Tooltip>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default ScrollTop;
